module.exports = __webpack_public_path__ + "static/media/fodor.3ffe9e08.jpg";